export default {
  getXeroAccount: (state) => state.xeroAccount,
};
